import React, { useCallback, useEffect, useState } from "react";

import { withoutReservedTags } from "@formant/core/common/withoutReservedTags";
import { IDeviceDetails } from "@formant/core/model/IDeviceDetails";
import { ITagSets } from "@formant/core/model/ITagSets";

import { deviceDetailsStore, deviceStore } from "../../../../stores";
import { ChooseDevices } from "./ChooseDevices";
import { ChooseTags } from "./ChooseTags";

interface IChooseFiltersProps {
    existingSelectedTags?: ITagSets;
    onSelectedDevicesChange?: (selectedDevices: IDeviceDetails[]) => void;
    onSelectedTagsChange?: (selectedTags: ITagSets) => void;
}

export const ChooseFilters: React.FC<IChooseFiltersProps> = ({
    existingSelectedTags,
    onSelectedDevicesChange,
    onSelectedTagsChange,
}) => {
    const [selectedTags, setSelectedTags] = useState<ITagSets>(
        existingSelectedTags || {},
    );
    const [devices, setDevices] = useState<any[]>([]);
    const [tags, setTags] = useState<ITagSets>({});

    useEffect(() => {
        const fetchDevices = async () => {
            const result = await deviceDetailsStore.listAsync({
                enabled: true,
                type: "default",
            });
            setDevices(result || []);
        };

        fetchDevices()
            .then(() => {
                console.log("devices", devices);
            })
            .catch(error => {
                console.error("Error fetching devices:", error);
            });
    }, []);

    useEffect(() => {
        const currentTags = withoutReservedTags(
            deviceStore.tags({
                enabled: true,
                type: "default",
            }) || {},
        );
        for (const key in currentTags) {
            if (currentTags[key]) {
                currentTags[key].forEach((tag, index) => {
                    if (tag === "") {
                        currentTags[key][index] = "*";
                    }
                });
            }
        }
        setTags(currentTags);
    }, []);

    const handleTagsChange = useCallback((currentSelectedTags: ITagSets) => {
        setSelectedTags(currentSelectedTags);
        onSelectedTagsChange?.(currentSelectedTags);
    }, []);

    const handleSelectedDevicesChange = useCallback(
        (currentSelectedDevices: IDeviceDetails[]) => {
            onSelectedDevicesChange?.(currentSelectedDevices);
        },
        [],
    );

    return (
        <div className="flex flex-col space-y-4">
            <h1 className="text-xl font-semibold text-white">
                Use tags to filter down to the desired devices to add.
            </h1>
            <ChooseTags
                tags={tags}
                currentTags={selectedTags}
                onTagsChange={handleTagsChange}
            />
            <ChooseDevices
                devices={devices}
                selectedTags={selectedTags}
                onSelectedDevicesChange={handleSelectedDevicesChange}
            />
        </div>
    );
};
